import { t } from 'ember-intl';
import type { TOC } from '@ember/component/template-only';
import pageTitle from 'ember-page-title/helpers/page-title';
import type PslfEmployerController from 'tio-employee/controllers/pslf-employer';

interface S {
  Args: {
    model: {
      pathToken: string;
    };
    controller: PslfEmployerController;
  };
}

const PslfEmployerPage: TOC<S> = <template>
  {{pageTitle (t "pslf.employer_sign_page_title")}}

  <div class="tio-col-flush h-screen container mx-auto">
    {{outlet}}
  </div>
</template>;

export default PslfEmployerPage;
